import {A} from 'components/atoms/LinksAndButtons/A';
import { LinkStyle } from 'features/ui/enums';
import {Icon} from 'components/atoms/Media/Icon';
import * as React from 'react';
import {gtmEventsInteractionDownloadFile} from 'features/services/googleTagManager/events';


import './style.scss';
import {LinkObject} from "features/template/viewModels/ResidenceStage";

interface Props {
    links: LinkObject[];
    externalLinksIcon?: boolean;
    externalLinksIconFirst?: boolean;
    whiteLink?: boolean;
}

export const LinkList: React.FunctionComponent<Props> = ({links, externalLinksIcon, externalLinksIconFirst, whiteLink}) => {
    if(!links) return null;

    return (
        <ul className="link-list">
            {links.map((link, index) => (
                <li
                    key={`link-${link.name}-${index}`}
                >
                    {link.isFile &&
                        <A
                            href={link.url}
                            target="_blank"
                            className='download'
                            attachedEvent={gtmEventsInteractionDownloadFile(link.url)}
                            title={link.name}
                        >
                            <Icon name="download" />
                            <span>{link.name}</span>
                        </A>
                    }
                    {!link.isFile &&
                        <A
                            href={link.url}
                            target={link.target}
                            variant={whiteLink ? LinkStyle.DARK_BG : LinkStyle.DEFAULT}
                            className='link'
                            title={link.name}
                        >
                            {link.url.indexOf('http') > -1 && externalLinksIconFirst &&
                                <Icon name="external-link" size={20} />
                            }
                            <span>{link.name}</span>
                        </A>
                    }
                    {link.target === '_blank' && externalLinksIcon && !externalLinksIconFirst &&
                        <Icon name="external-link" size={20} />
                    }
                </li>
            ))}
        </ul>
    )
};
